module.exports = "/templates/documentlibrary.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/documentlibrary.html
// module id = 446
// module chunks = 0